import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { ErrorHandling } from '../../@types/ErrorHandling'
import {
  GetEntitiesDetailsClientRequest,
  GetEntitiesDetailsClientResponse,
} from '../../@types/GetEntitiesDetails'
import { ENV } from '../../Environment'
import { api } from '../../Services/API'
import { useReportStore } from '../../Stores/reportStore'
import { useSimulatorStore } from '../../Stores/simulatorStore'
import { useGetEntitiesDetailsStore } from '../../Stores/useGetEntitiesDetailsStore'
import { API_ROUTES } from '../../constants/apiRoutes'
import { ID_EXTERNAL_TYPES } from '../../constants/idExternalTypes'
import { useErrorRequest } from '../useErrorRequest'

const NOT_FOUND = 404

const headers = {
  'aip-company': ENV().CompanyAgeas,
  'aip-channel': ENV().GetEntityDetails.Channel,
}

const request = async (payload: GetEntitiesDetailsClientRequest) => {
  const response = await api.post<GetEntitiesDetailsClientResponse>(
    API_ROUTES.getEntitiesDetails,
    payload,
    { headers },
  )

  return response.data
}

export const useGetEntitiesDetails = () => {
  const { setEntitySelected, setOwnerFiscalNumber } = useSimulatorStore()
  const { setReport, setIsNifSearched, setIsProspect } = useReportStore()
  const { setGetEntitiesDetails } = useGetEntitiesDetailsStore()
  const { handleErrorRequest } = useErrorRequest()

  return useMutation({
    mutationFn: (payload: GetEntitiesDetailsClientRequest) => request(payload),
    onSuccess(data) {
      setGetEntitiesDetails(data!)
      setIsProspect(false)
      setIsNifSearched(false)

      if (
        data.matchedEntities?.[0].idExternalType?.toUpperCase() ===
        ID_EXTERNAL_TYPES.isPartner
      ) {
        const prospectEntity = data.matchedEntities?.[0]

        setReport({
          vatNumber: prospectEntity.vatNumber || '',
          name: prospectEntity.name || '',
          phone: prospectEntity.entityPhone || '',
          email: prospectEntity.emailContactsList?.[0]?.email || '',
        })
      }
    },
    onError(error: AxiosError<ErrorHandling[]>) {
      setEntitySelected(null)
      if (error.response?.status === NOT_FOUND) {
        setOwnerFiscalNumber(JSON.parse(error.response?.config.data).vatNumber)
        setReport({
          vatNumber: JSON.parse(error.response?.config.data).vatNumber || '',
        })
        setIsProspect(true)
        setIsNifSearched(true)
        return
      }

      handleErrorRequest({ error })
    },
  })
}
